import { render, staticRenderFns } from "./SecuritySettings.vue?vue&type=template&id=78185a52"
import script from "./SecuritySettings.vue?vue&type=script&lang=js"
export * from "./SecuritySettings.vue?vue&type=script&lang=js"
import style0 from "./SecuritySettings.vue?vue&type=style&index=0&id=78185a52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports